import {billingNewGatewayInterface} from "../../../corelogic/usecases/billing-new/billingNewGatewayInterface";
import {Invoice} from "../../../corelogic/models/entities/billing-new/invoice";

export default class APIBillingNewGateway implements billingNewGatewayInterface {
	error: any;

	setError = (error: boolean) => {
		this.error = error;
	};

	async getInvoices(participantIds: number[]): Promise<Invoice[] | null> {
		const participantId = participantIds[0];
		switch (participantId) {
			case 1:
				return [
					new Invoice(1, "I-001", "2024-01-01", "2024-01-31", 45.25, 101, participantId, false),
					new Invoice(2, "I-002", "2024-02-01", "2024-02-29", 52.8, 102, participantId, false),
					new Invoice(3, "I-003", "2024-03-01", "2024-03-31", 38.9, 103, participantId, false),
				];
			case 2:
				return [
					new Invoice(4, "I-004", "2024-01-01", "2024-01-31", 67.45, 104, participantId, false),
					new Invoice(5, "I-005", "2024-02-01", "2024-02-29", 73.2, 105, participantId, false),
					new Invoice(6, "I-006", "2024-03-01", "2024-03-31", 81.15, 106, participantId, false),
					new Invoice(7, "I-007", "2024-04-01", "2024-04-30", 69.8, 107, participantId, false),
				];
			case 3:
				return [
					new Invoice(8, "I-008", "2024-01-01", "2024-01-31", 29.95, 108, participantId, false),
					new Invoice(9, "I-009", "2024-02-01", "2024-02-29", 34.6, 109, participantId, false),
				];
			case 4:
				return [
					new Invoice(10, "I-010", "2024-01-01", "2024-01-31", 95.3, 110, participantId, false),
					new Invoice(11, "I-011", "2024-02-01", "2024-02-29", 102.45, 111, participantId, false),
					new Invoice(12, "I-012", "2024-03-01", "2024-03-31", 88.75, 112, participantId, false),
					new Invoice(13, "I-013", "2024-04-01", "2024-04-30", 115.2, 113, participantId, false),
					new Invoice(14, "I-014", "2024-05-01", "2024-05-31", 97.8, 114, participantId, false),
				];
			case 5:
				return [
					new Invoice(15, "I-015", "2024-01-01", "2024-01-31", 42.15, 115, participantId, false),
					new Invoice(16, "I-016", "2024-02-01", "2024-02-29", 48.9, 116, participantId, false),
					new Invoice(17, "I-017", "2024-03-01", "2024-03-31", 55.65, 117, participantId, false),
				];
			case 6:
				return [
					new Invoice(18, "I-018", "2024-01-01", "2024-01-31", 78.4, 118, participantId, false),
					new Invoice(19, "I-019", "2024-02-01", "2024-02-29", 85.25, 119, participantId, false),
					new Invoice(20, "I-020", "2024-03-01", "2024-03-31", 92.1, 120, participantId, false),
					new Invoice(21, "I-021", "2024-04-01", "2024-04-30", 76.85, 121, participantId, false),
				];
			default:
				return [new Invoice(0, "I-DEFAULT", "2024-01-01", "2024-01-31", 50.0, 100, participantId, false)];
		}
	}
	async downloadInvoice(participantId: number, invoiceId: number): Promise<void> {
		return Promise.resolve(undefined);
	}
}
